<template>
  <!-- User logged-in -->
  <v-menu
    v-if="user"
    light
    offset-y
    left
    min-width="225px"
    transition="slide-y-transition"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        dark
        icon
        title="Account"
        v-on="on"
      >
        <v-icon>person</v-icon>
      </v-btn>
    </template>
    <div
      class="px-4 py-6 white text-subtitle-1 font-weight-medium user-banner"
      @click.stop
    >
      {{ user.email }}
    </div>

    <v-list class="py-0">
      <v-list-item to="/user">
        <v-list-item-content>
          <v-list-item-title>Account Settings</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-icon>settings</v-icon>
        </v-list-item-action>
      </v-list-item>
      <v-divider />
      <v-list-item href="/logout">
        <v-list-item-content>
          <v-list-item-title>Logout</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-icon>logout</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </v-menu>

  <!-- No User -->
  <v-btn
    v-else
    dark
    text
    class="ma-0"
    @click="loginDialog = true"
  >
    Log In
  </v-btn>
</template>

<script>
// Modules
import { mapState } from 'vuex'
import { mapFields } from 'vuex-map-fields'

export default {
  computed: {
    ...mapState('user', ['user']),
    ...mapFields({
      loginDialog: 'app.loginDialog'
    })
  }
}
</script>

<style lang="scss" scoped>
.user-banner {
  letter-spacing: 0.01em;
  border-bottom: 3px solid rgba(0,0,0,.12) !important;
}
</style>
